import { useRef } from 'react';
import { Table } from 'react-bootstrap';
import { TbFileSpreadsheet } from 'react-icons/tb';
import { useReactToPrint } from "react-to-print";

const PrintLoadSheet = ({ title, orders }) => {

    const contentRef = useRef(null);

    const reactToPrintFn = useReactToPrint({
        contentRef,
        pageStyle: `
            @media print {
                @page {
                    size: A4 !important;
                }

                table {
                    width: 100%;
                }
            }
        `
    });

    const currentDate = new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });


    const getCityFromAddress = (address) => {
        const match = address?.match(/([\w\s]+?)[,\s]*\(\s*CNIC NO/);
        return match ? match[1].trim().split(" ").pop() : address;
    };

    return (
        <>
            <div>
                <button onClick={reactToPrintFn} className="oms-btn oms-btn-primary" >

                    <TbFileSpreadsheet />

                    {title}


                </button>

                {/* <button onClick={reactToPrintFn} className="oms-btn oms-btn-ghost ">
                    {title}
                </button> */}


                <div ref={contentRef} className='printContent'>
                    {/* <div ref={contentRef}> */}

                    {/* Header */}
                    <div className='row fw-bold mt-3'>
                        <div className="col">
                            <h6 className='fw-bold'>
                                Load Sheet Of VPP Parcel Of AR E Cart At Nazimabad HPO
                            </h6>
                        </div>
                        <div className="col-auto">
                            Dated : {currentDate}
                        </div>
                    </div>
                    <div className="print">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Order ID</th>
                                    <th>VPP Number</th>
                                    <th>Name</th>
                                    <th>Address</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((o, i) => (
                                    <tr key={o.id}>
                                        <td>{i + 1}</td>
                                        <td>{o.trackingId}</td>
                                        <td>{o.VppNumber}</td>
                                        <td>{o.customerName}</td>
                                        <td>{o.city ? o.city : getCityFromAddress(o.address)}</td>
                                        {/* <td>{o.address}</td> */}
                                        <td>
                                            {o?.amount
                                                ? (Number(o.amount) < 10000
                                                    ? Number(o.amount) - 75
                                                    : Number(o.amount) - 100)
                                                : 0}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                </div>
            </div>
        </>
    )
}

export default PrintLoadSheet;